<cm-configurator #sceneViewer [templateUuid]="$templateId()" [showUi]="true" [forceWebGl]="false" class="cm-viewport"></cm-configurator>
